import { render, staticRenderFns } from "./landingApproval.vue?vue&type=template&id=4c8a1c1e&scoped=true&"
import script from "./landingApproval.vue?vue&type=script&lang=ts&"
export * from "./landingApproval.vue?vue&type=script&lang=ts&"
import style0 from "./landingApproval.vue?vue&type=style&index=0&id=4c8a1c1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8a1c1e",
  null
  
)

export default component.exports